var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "offer-counter",
      class: { "offer-counter--counting": _vm.counting }
    },
    [
      _c(
        "span",
        { staticClass: "offer-counter__number" },
        [
          _c("ICountUp", {
            attrs: { startVal: _vm.startVal, endVal: _vm.endVal, decimals: 0 },
            on: {
              ready: function($event) {
                _vm.ready = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "offer-counter__text",
        domProps: { textContent: _vm._s(_vm.translations.offer_header) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95771cf8", { render: render, staticRenderFns: staticRenderFns })
  }
}